<template>
  <div class="jc"
       :style="{height:height1}">
    <div class="choose">
      <div class="xuan"
           :style="{background:background,color:color}"
           @click="fun">数据类别介绍</div>

      <div class="xuan"
           :style="{background:background3,color:color3}"
           @click="fun3">操作指南</div>

      <div class="xuan"
           :style="{background:background4,color:color4}"
           @click="fun4">已知范例</div>

      <div class="xuan"
           :style="{background:background1,color:color1}"
           @click="fun1">数据介绍</div>

      <div class="xuan"
           :style="{background:background2,color:color2}"
           @click="fun2">公众科学简介</div>

    </div>

    <div class="jc-one"
         :style="{height:height}">
      <!-- 形态分类 -->
      <morphology @pass="passon"
                  v-show="is"></morphology>
      <!-- 数据 -->
      <shuju v-show="is1"></shuju>
      <!-- 科学 -->
      <science v-show="is2"></science>
      <!-- 操作指南 -->
      <guide v-show="is3"></guide>
      <!-- 已知范例 -->
      <paradigm v-show="is4"></paradigm>
    </div>
  </div>
</template>

<script>
import morphology from '../components/morphology.vue'
import shuju from '../components/shuju.vue'
import science from '../components/science.vue'
import guide from '../components/guide.vue'
import paradigm from '../components/paradigm.vue'
export default {
  data () {
    return {
      is: true,
      is1: false,
      is2: false,
      is3: false,
      is4: false,
      height1: "100%",
      height: "100%",
      background: "rgb(238,46,49)",
      background1: "",
      background2: "",
      background3: "",
      background4: "",
      color: "white",
      color1: "",
      color2: "",
      color3: "",
      color4: "",
      // 接受路由的指南参数
      ly: '',
      // 接受路由的数据参数
      sj: '',
      // 接受路由的星系参数
      star: '',
      // 接收子组件传值
      fanli: '',
    }
  },
  created () {
    // this.$bus.$on('openDemandList', () => {

    // })
  },
  mounted () {
    this.ly = this.$route.params.is
    if (this.ly) {
      this.fun3()
    }

    this.sj = this.$route.params.iss
    if (this.sj) {
      this.fun1()
    }

    this.star = this.$route.params.star
    if (this.star) {
      this.fun()
    }
  },
  methods: {
    fun () {
      this.background = "rgb(238,46,49)"
      this.background1 = ""
      this.background2 = ""
      this.background3 = ""
      this.background4 = ""
      this.color = "white"
      this.color1 = ""
      this.color2 = ""
      this.color3 = ""
      this.color4 = ""
      this.height1 = "100%"
      this.height = "100%"
      this.is = true
      this.is1 = false
      this.is2 = false
      this.is3 = false
      this.is4 = false
    },
    fun1 () {
      this.background = ""
      this.background1 = "rgb(238,46,49)"
      this.background2 = ""
      this.background3 = ""
      this.background4 = ""
      this.color = ""
      this.color1 = "white"
      this.color2 = ""
      this.color3 = ""
      this.color4 = ""
      this.height1 = "100%"
      this.height = "100%"
      this.is = false
      this.is1 = true
      this.is2 = false
      this.is3 = false
      this.is4 = false
    },
    fun2 () {
      this.background = ""
      this.background1 = ""
      this.background2 = "rgb(238,46,49)"
      this.background3 = ""
      this.background4 = ""
      this.color = ""
      this.color1 = ""
      this.color2 = "white"
      this.color3 = ""
      this.color4 = ""
      this.height1 = "100%"
      this.height = "100%"
      this.is = false
      this.is1 = false
      this.is2 = true
      this.is3 = false
      this.is4 = false
    },
    fun3 () {
      this.background = ""
      this.background1 = ""
      this.background2 = ""
      this.background3 = "rgb(238,46,49)"
      this.background4 = ""
      this.color = ""
      this.color1 = ""
      this.color2 = ""
      this.color3 = "white"
      this.color4 = ""
      this.height1 = "100%"
      this.height = "100%"
      this.is = false
      this.is1 = false
      this.is2 = false
      this.is3 = true
      this.is4 = false
    },
    fun4 () {
      this.background = ""
      this.background1 = ""
      this.background2 = ""
      this.background3 = ""
      this.background4 = "rgb(238,46,49)"
      this.color = ""
      this.color1 = ""
      this.color2 = ""
      this.color3 = ""
      this.color4 = "white"
      this.height = "100%"
      this.height1 = "100%"
      this.is = false
      this.is1 = false
      this.is2 = false
      this.is3 = false
      this.is4 = true
    },

    // 父组件接收
    passon (val) {
      this.fanli = val
      if (this.fanli) {
        this.fun4()
      }
    }
  },
  components: {
    morphology,
    shuju,
    science,
    guide,
    paradigm
  }
};
</script>

<style lang="scss" scoped>
.jc {
  width: 100%;
  background-color: rgb(242, 242, 242);
  padding-top: 140px;
  padding-bottom: 10px;
  .choose {
    display: flex;
    justify-content: space-between;
    width: 84.2%;
    margin-left: 95px;
    margin-top: -130px;
    height: 90px;
    padding-top: 30px;
    font-size: 18px;
    .xuan {
      width: 100%;
      height: 60px;
      text-align: center;
      line-height: 60px;
      border-radius: 5px;
      cursor: pointer; /*悬停变小手的属性*/
    }
    .xuan:hover {
      color: rgb(64, 158, 255);
    }
  }
  .jc-one {
    padding: 30px;
    margin-left: 100px;
    margin-top: 25px;
    width: 80%;
    background-color: rgb(254, 254, 254);
    margin-bottom: 50px;
  }
}
</style>
